import React from 'react'
import PropTypes from 'prop-types'
import { View, StyleSheet } from '@react-pdf/renderer'
import Text from './Text'
import MainTitleLogo from './icons/MainTitleLogo'

// Create styles
const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '22px 0',
  },
  title: {
    fontWeight: 700,
    fontFamily: 'Inter-Bold',
    fontSize: 18,
  },
  textContainer: {
    flexDirection: 'column',
    gap: 0
  },
  topTitle: {
    fontSize: 12,
    fontWeight: 500,
    marginBottom: 0,
  },
  bottomTitle: {
    fontSize: 12,
    marginTop: 0,
  },
  meddiumTitle: {
    fontWeight: 700,
    fontFamily: 'Inter-Bold',
    fontSize: 18,
    marginTop: 5,
    marginBottom: 5,
  },
  topContainer: {
    display: 'flex',
    flexDirection: 'column',
    margin: '22px 0 22px 0',
    gap: 0,
    justifyContent: 'space-between',
  },
  internalContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
})

// Create Document Component
export const MainTitle = ({
  text, titleColor, insurer, topTitle, bottomTitle, bottomTitleColor, topTitleColor
}) => {
  return topTitle && bottomTitle ? (
    <View style={styles.topContainer}>
      <View style={styles.internalContainer}>
        <View style={styles.textContainer}>
          <Text style={{ ...styles.topTitle, color: topTitleColor }}>{topTitle}</Text>
          <Text style={{ ...styles.meddiumTitle, borderColor: titleColor }}>
            {text || 'Relatório de saúde preventiva'}
          </Text>
        </View>
        <MainTitleLogo
          insurer={insurer}
        />
      </View>
      <Text style={{ ...styles.bottomTitle, color: bottomTitleColor }}>{bottomTitle}</Text>

    </View>
  )
    : (
      <View style={styles.container}>
        <Text style={{ ...styles.title, borderColor: titleColor }}>
          {text || 'Relatório de saúde preventiva'}
        </Text>
        <MainTitleLogo insurer={insurer} />
      </View>
    )
}

MainTitle.propTypes = {
  text: PropTypes.string,
  titleColor: PropTypes.string,
  insurer: PropTypes.string,
  topTitle: PropTypes.string,
  bottomTitle: PropTypes.string,
  bottomTitleColor: PropTypes.string,
  topTitleColor: PropTypes.string,
}

MainTitle.defaultProps = {
  text: 'Relatório de saúde preventiva',
  titleColor: '#000',
  insurer: 'unimed',
  topTitle: '',
  bottomTitle: '',
  bottomTitleColor: '#000',
  topTitleColor: '#000',
}
